import type { Plan } from '@/services/api/api.types'

/**
 * Keeps only the per-user seat plans. Credit packs share the bundles table, so seat pricing must
 * never see them. Mirrors BillingPlan.seat_plans() in backend_common_functions, which keys on the
 * plan type alone: a seat row with no maxUsers is still a tier the backend bills.
 */
export function getSeatPlans(plans: Plan[]): Plan[] {
  return plans.filter(plan => plan.planType !== 'credit_pack')
}

/**
 * The flat per-user price. Mirrors seat_tiers() in backend_common_functions: the default row is
 * the invite allowance rather than a price, and every other active seat row is a billing tier.
 * Tiers at more than one price mean graduated billing, so there is no single rate to state.
 */
export function getSeatPrice(plans: Plan[]): number | null {
  const prices = new Set(
    getSeatPlans(plans)
      .filter(plan => plan.active && !plan.isDefault)
      .map(plan => plan.priceDollars),
  )
  return prices.size === 1 ? [...prices][0] : null
}

export function formatDollars(dollars: number): string {
  return Number.isInteger(dollars) ? `$${dollars}` : `$${dollars.toFixed(2)}`
}
